"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Title = exports.LinkImitation = exports.Inner = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _types = require("../../types");
const Inner = exports.Inner = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { theme, promoBannerType } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        padding: theme.spacing(3),
        gap: promoBannerType === _types.PromoBannerType.Text ? theme.spacing(3) : theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            gap: promoBannerType === _types.PromoBannerType.Text ? theme.spacing(4) : theme.spacing(3)
        }
    };
});
const Title = exports.Title = (0, _mui.styled)(_mui.Typography, {
    shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)([
        'promoBannerType'
    ])
})((param)=>{
    let { promoBannerType } = param;
    return {
        display: '-webkit-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        WebkitLineClamp: promoBannerType === _types.PromoBannerType.Text ? 5 : 2,
        WebkitBoxOrient: 'vertical',
        textAlign: 'center'
    };
});
const LinkImitation = exports.LinkImitation = (0, _mui.styled)(_mui.Typography, {
    shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)([
        'promoBannerType'
    ])
})((param)=>{
    let { promoBannerType, theme } = param;
    return {
        textTransform: 'uppercase',
        fontWeight: theme.typography.fontWeightBold,
        textUnderlineOffset: '2px',
        paddingBottom: theme.spacing(0.5),
        display: '-webkit-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        WebkitLineClamp: promoBannerType === _types.PromoBannerType.Text ? 2 : 1,
        WebkitBoxOrient: 'vertical',
        textAlign: 'center',
        [theme.breakpoints.up('sm')]: {
            WebkitLineClamp: 2
        }
    };
});
